import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetIsSac, GetIsSacResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetIsSacResponse, GetIsSacResponse>) => response?.data?.isSac;

const getError = (response?: SWRResponse<GetIsSacResponse, GetIsSacResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetIsSacResponse, GetIsSacResponse>) => ({
    isSac: response?.data?.isSac
});

export const useSacStatus = (firstName?: string, lastName?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!firstName || !lastName) {
            return undefined;
        }
        
        return () => {
            return new GetIsSac({firstName, lastName});
        };
    }, [firstName, lastName])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useSacStatus;
